import styled from 'styled-components';
import { Ui }from '@einstein/schedule-platform';

import ConsultScheduleButton from '../ConsultScheduleButton';
import ListLinks from '../Link';

const DefaultContent = styled.div`
  padding-top: 40px;
  padding-left: 18px;
  padding-right: 18px;
`;

type MenuProps = {
  isOpen: boolean;
  onClose: () => void;
  handleConsultSchedule: () => void;
};

const Menu = ({ isOpen, onClose, handleConsultSchedule }: MenuProps) => {
  return (
    <Ui.Sidebar visible={isOpen} onClose={onClose}>
      <ListLinks onCloseNav={onClose} />

      <DefaultContent>
        <ConsultScheduleButton handleConsultSchedule={handleConsultSchedule} />
      </DefaultContent>
    </Ui.Sidebar>
  );
};

export default Menu;
